import * as React from 'react';
import { ListItemIcon, ListItem, ListItemText } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { CartContext } from '../CartContext/CartContext';
import { Brightness4, Brightness7 } from '@material-ui/icons';

export default function ModeThemeDrawer() {
  const theme = useTheme();
  const cartContext = React.useContext(CartContext);
  const { setModeTheme } = cartContext;
  const mode = theme.palette.mode || theme.palette.type || 'light';
  const isDark = mode === 'dark';

  const toggleColorMode = React.useCallback(() => {
    setModeTheme((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  }, [setModeTheme]);

  return (
    <ListItem button onClick={toggleColorMode} sx={{ cursor: 'pointer', justifyContent: 'center' }}>
      <ListItemIcon sx={{ minWidth: 'auto', mr: 1, color: 'text.primary' }}>
        {isDark ? <Brightness7 fontSize="small" /> : <Brightness4 fontSize="small" />}
      </ListItemIcon>
      <ListItemText
        primary={isDark ? 'Modo claro' : 'Modo oscuro'}
        sx={{ flex: '0 0 auto' }}
      />
    </ListItem>
  );
}
